import React, { useState } from "react";
import { Form, Button, Modal, Tabs } from "antd";
import styles from "../management.module.scss";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hook";
import { custInfRecordProps } from "../index";
import CreateGroup from "./GroupModalF_Create";
import EditGroup from "./GroupModalF_Edit";
import { useNodeInf } from "../queries";

interface groupModalProps {
  GroupModalvisible: boolean;
  setGroupModalvisible: (arg: boolean) => void;
  record: custInfRecordProps;
  setRecord: (arg: custInfRecordProps) => void;
}

const { TabPane } = Tabs;

const GroupModalC = React.memo(({ GroupModalvisible, setGroupModalvisible, record, setRecord }: groupModalProps) => {
  const [EditGroupform] = Form.useForm();
  const [CreateGroupform] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const { data: devicesNodeInf, isFetching: devicesNodeInfFetching } = useNodeInf(record?.cid, GroupModalvisible);
  const [currentPage, setCurrentPage] = useState("1");
  const { t } = useTranslation();

  const callback = (page: string) => {
    setCurrentPage(page);
  };

  const createProps = {
    record,
    CreateGroupform,
    setCurrentPage,
    GroupModalvisible,
    devicesNodeInf,
  };
  const editProps = {
    record,
    setCurrentPage,
    setEditingKey,
    editingKey,
    EditGroupform,
    GroupModalvisible,
    devicesNodeInf,
  };

  return (
    <Modal
      title={t("ISMS.Group")}
      visible={GroupModalvisible}
      onCancel={() => {
        setGroupModalvisible(false);
        setRecord({ cid: undefined });
        setCurrentPage("1");
        setEditingKey("");
      }}
      centered={true}
      className={styles.modal}
      destroyOnClose={true}
      footer={[
        currentPage === "1" && (
          <Button loading={devicesNodeInfFetching} key="back" type="primary" onClick={() => CreateGroupform.submit()}>
            {t("ISMS.Submit")}
          </Button>
        ),
        currentPage === "2" && (
          <Button
            key="ok"
            type="primary"
            loading={devicesNodeInfFetching}
            onClick={() => {
              if (editingKey !== "") {
                EditGroupform.submit();
              } else {
                setGroupModalvisible(false);
                setCurrentPage("1");
              }
            }}
          >
            {editingKey !== "" ? t("ISMS.Submit") : t("ISMS.Confirm")}
          </Button>
        ),
      ]}
    >
      <Tabs defaultActiveKey="1" onChange={callback} activeKey={currentPage}>
        <TabPane tab={t("ISMS.Create Group")} key="1">
          <CreateGroup {...createProps} />
        </TabPane>
        <TabPane tab={t("ISMS.EditGroup")} key="2" className={styles.groupPane}>
          <EditGroup {...editProps} />
        </TabPane>
      </Tabs>
    </Modal>
  );
});

export default GroupModalC;
